import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ShareDataService } from 'src/app/services/share-data.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-success-snackbar',
  templateUrl: './success-snackbar.component.html',
  styleUrls: ['./success-snackbar.component.scss']
})
export class SuccessSnackbarComponent implements OnInit {
  snackbarMessage : string;
  isUndoAvailble: boolean;

  constructor(private dataSource: SnackBarService,
              private shareDataService: ShareDataService,
              private _snackRef: MatSnackBarRef<SuccessSnackbarComponent>) { }

  ngOnInit(): void {
    this.snackbarMessage = this.dataSource.snackBarMessage;
    this.isUndoAvailble = this.dataSource.isUndoAvailble;
  }

  onUndoClick(value) {
   this.shareDataService.setUndoButtonInfo(value);
   this._snackRef.dismiss();
  }
}